import * as S from './Card.style';

const Card: React.FC<{
  children: React.ReactNode;
  testId: string;
  variant?: string;
  onClick?: () => void;
}> = ({ children, testId, variant, onClick }) => {
  const othersAttributes = onClick ? { onClick } : {};
  return (
    <S.Card data-testid={testId} variant={variant} {...othersAttributes}>
      {children}
    </S.Card>
  );
};

Card.defaultProps = {
  variant: 'stacked',
};

export default Card;
